import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class NurseryPaymentTitle extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): NurseryPaymentTitle {
    return new NurseryPaymentTitle(value);
  }
}
